export const actionTypes = {
  REMOVE_TOAST: "REMOVE_TOAST",
  UPDATE_OVERHEAD_DATA: "UPDATE_OVERHEAD_DATA",

  GET_OVERHEAD: "GET_OVERHEAD",
  GET_OVERHEAD_SUCCESS: "GET_OVERHEAD_SUCCESS",
  GET_OVERHEAD_FAILED: "GET_OVERHEAD_FAILED",
  CREATE_OVERHEAD: "CREATE_OVERHEAD",
  CREATE_OVERHEAD_SUCCESS: "CREATE_OVERHEAD_SUCCESS",
  CREATE_OVERHEAD_FAILED: "CREATE_OVERHEAD_FAILED",
  COPY_OVERHEAD: "COPY_OVERHEAD",
  COPY_OVERHEAD_SUCCESS: "COPY_OVERHEAD_SUCCESS",
  COPY_OVERHEAD_FAILED: "COPY_OVERHEAD_FAILED",
  UPDATE_OVERHEAD: "UPDATE_OVERHEAD",
  UPDATE_OVERHEAD_SUCCESS: "UPDATE_OVERHEAD_SUCCESS",
  UPDATE_OVERHEAD_FAILED: "UPDATE_OVERHEAD_FAILED",
  DELETE_OVERHEAD: "DELETE_OVERHEAD",
  DELETE_OVERHEAD_SUCCESS: "DELETE_OVERHEAD_SUCCESS",
  DELETE_OVERHEAD_FAILED: "DELETE_OVERHEAD_FAILED",
}

const initialState = {
  data: null,
  meta: null,
  isLoading: false,
  toast: null,
  errors: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REMOVE_TOAST:
      return Object.assign({}, state, {
        toast: null
      })
    case actionTypes.UPDATE_OVERHEAD_DATA:
      return Object.assign({}, state, {
        data: action.state
      })
    case actionTypes.GET_OVERHEAD:
    case actionTypes.CREATE_OVERHEAD:
    case actionTypes.COPY_OVERHEAD:
    case actionTypes.UPDATE_OVERHEAD:
    case actionTypes.DELETE_OVERHEAD:
      return Object.assign({}, state, { isLoading: true, errors: null });
    case actionTypes.GET_OVERHEAD_FAILED:
    case actionTypes.CREATE_OVERHEAD_FAILED:
    case actionTypes.COPY_OVERHEAD_FAILED:
    case actionTypes.UPDATE_OVERHEAD_FAILED:
    case actionTypes.DELETE_OVERHEAD_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        errors: action.errors
      });
    case actionTypes.GET_OVERHEAD_SUCCESS:
      return Object.assign({}, state, {
        data: action.payload.data,
        meta: action.payload.meta,
        isLoading: false,
        errors: null,
      });
    case actionTypes.CREATE_OVERHEAD_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: { type: "success", message: "Succesfully added expense ", request: "add" }
      });
    case actionTypes.COPY_OVERHEAD_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: { type: "success", message: "Successfully coped expenses", request: "copy" }
      })
    case actionTypes.UPDATE_OVERHEAD_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: { type: "success", message: "Successfully updated expense", request: "edit" }
      });
    case actionTypes.DELETE_OVERHEAD_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: { type: "success", message: "Successfully deleted expense" }
      })
    default:
      return state;
  }
}

export const actionCreators = {
  removeToast: () => ({
    type: actionTypes.REMOVE_TOAST
  }),
  updateOverheadData: state => ({
    type: actionTypes.UPDATE_OVERHEAD_DATA, state
  }),
  getOverhead: (company_id, params) => ({
    type: actionTypes.GET_OVERHEAD,
    company_id, params
  }),
  createOverhead: (payload) => ({
    type: actionTypes.CREATE_OVERHEAD, payload
  }),
  copyOverhead: (company_id, body) => ({
    type: actionTypes.COPY_OVERHEAD,
    company_id, body
  }),
  updateOverhead: (company_id, overhead_id, body) => ({
    type: actionTypes.UPDATE_OVERHEAD,
    company_id,
    overhead_id,
    body
  }),
  deleteOverhead: (company_id, overhead_id) => ({
    type: actionTypes.DELETE_OVERHEAD,
    company_id,
    overhead_id
  })
}


// WEBPACK FOOTER //
// ./src/modules/company/pages/overhead/reducer.js